import script from "./UpdateEmailConfirmationView.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateEmailConfirmationView.vue?vue&type=script&setup=true&lang=js"

import "./UpdateEmailConfirmationView.vue?vue&type=style&index=0&id=f21dc080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f21dc080"]])

export default __exports__